<template>
  <div>
    <div class="wrapper-x-40">
      <h1>{{$t('admin.views.search.h1')}}</h1>
    </div>
    <div class="content">
      <div class="wrapper-x-40">
        <div>
          <div v-if="results && results.length > 0">
            <div class="element-list table-list-wrapper">
              <table>
                <thead>
                  <tr>
                    <th class="image-name">{{$t('admin.views.search.column_name')}}:</th>
                    <th class="type">{{$t('admin.views.search.column_type')}}:</th>
                    <th class="cost">{{$t('admin.views.search.column_currency')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="result in results"
                    :key="result.id"
                  >
                    <td class="image-name">
                      <router-link :to="{
                          name: result.route_name,
                          params: {
                            slug: (result.route_name == 'edit_element'||result.route_name == 'edit_landscaping'||result.route_name == 'edit_engraving' ) && result.slug,
                            order_id: result.route_name == 'order_detail' && result.id,
                            barrier_id: result.route_name == 'edit_barrier' && result.id,
                            element_id: (result.route_name == 'edit_element'||result.route_name == 'edit_landscaping'||result.route_name == 'edit_engraving') && result.id,
                          },
                        }">
                        {{ result.name }}
                      </router-link>
                    </td>
                    <td class="type">
                      {{ result.type_show }}
                    </td>
                    <td class="size">
                      {{ $toCurrency(result.cost) }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <PaginationBar
                :meta="meta"
                :page="page"
                :per-page="per_page"
                :per-pages="perPages"
                @set-page="setPage"
                @set-per-page="setPerPage"
              />
            </div>
          </div>
          <div v-else>{{$t('admin.views.search.no_result')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationBar from "../../components/Admin/PaginationBar.vue";

export default {
  name: "Search",
  components: { PaginationBar },
  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
    search() {
      return this.$store.state.adminSearch.search;
    },
    results() {
      return this.$store.state.adminSearch.results;
    },
    meta() {
      return this.$store.state.adminSearch.meta;
    },
    page() {
      return this.$store.state.adminSearch.page;
    },
    per_page() {
      return this.$store.state.adminSearch.per_page;
    },
    perPages() {
      return this.$store.state.settings.perPages;
    },
  },
  mounted() {
    //проверяем задана ли поисковая фраза
    // if (this.search.length > 2) {
    //   this.$store.dispatch("adminSearch/fetch");
    // }

  },
  methods: {
    setPage(page) {
      this.$store.dispatch("adminSearch/setPage", page);
    },
    setPerPage(event) {
      this.$store.dispatch(
        "adminSearch/setPerPage",
        event.target && event.target.value ? event.target.value : event
      );
    },
  },
};
</script>
